import axios from "axios";
import {api1031BuyerUrl, apiListedClosedUrl, apiNegUCUrl} from "./apiBaseUrls";
import {executeQuery} from "./executeQuery";
import {JUST_LISTED_JUST_CLOSED_PROPERTY, NEGOTIATION_UNDER_CONTRACT_PROPERTY, PROPERTY_DATA_DEFAULT_EMAIL} from "../consts/queries";
import {formatName} from "../utils";
import {emailEnv, env} from '../consts/env';

export function send1031BuyerEmail(res) {
    if (env) return;

    axios({
        method: 'post',
        url: api1031BuyerUrl,
        headers: {'Accept': '*'},
        data: {
            CATEGORY: res.CATEGORY,
            TYPE: res.TYPE,
            MARKET: res.MARKET,
            TENANT_SUBCATEGORY: res.TENANT_SUBCATEGORY,
            PRICE_MIN: res.PRICE_MIN,
            PRICE_MAX: res.PRICE_MAX,
            CAP_RATE_MIN: res.CAP_RATE_MIN,
            CAP_RATE_MAX: res.CAP_RATE_MAX,
            STRIVE_AGENT: res.STRIVE_AGENT,
            EMAIL_ENV: '',
        },
    });
}

export function sendListedClosedEmail(property) {
    if (env) return;

    executeQuery({
        queryName: JUST_LISTED_JUST_CLOSED_PROPERTY,
        params: {
            PROPERTY_ID: property.ARCIMEDES_ROW_ID,
        }
    }).then(data => {
        if (data.success && data.data.length) {
            axios({
                method: 'post',
                url: apiListedClosedUrl,
                headers: {'Accept': '*'},
                data: {
                    propertyId: property.ARCIMEDES_ROW_ID,
                    status: property.STATUS,
                    data: {...data.data[0]},
                    EMAIL_ENV: '',
                },
            });
        }
    });
}

export function sendNegotiationUnderContractEmail(property) {
    if (env) return;

    executeQuery({
        queryName: NEGOTIATION_UNDER_CONTRACT_PROPERTY,
        params: {
            PROPERTY_ID: property.ARCIMEDES_ROW_ID,
        }
    }).then(res => {
        if (res.success && res.data.length) {
            axios({
                method: 'post',
                url: apiNegUCUrl,
                headers: {'Accept': '*'},
                data: {
                    STATUS: res.data[0].STATUS,
                    NAME: res.data[0].NAME,
                    CITY: res.data[0].CITY,
                    STATE: res.data[0].STATE,
                    NEGOTIATION_PRICE: res.data[0].NEGOTIATION_PRICE,
                    CAP_RATE: res.data[0].NEGOTIATION_CAP_RATE,
                    AGENT_NAME: res.data[0].BUYER_AGENT_FIRST_NAME ? formatName(res.data[0], 'BUYER_AGENT_') : formatName(res.data[0], 'AGENT_'),
                    BUYER_NAME: formatName(res.data[0], 'BUYER_'),
                    EMAIL_ENV: '',
                },
            });
        }
    });
}

export function sendDefaultEmail(property, url) {
    if (env) return;

    executeQuery({
        queryName: PROPERTY_DATA_DEFAULT_EMAIL,
        params: {
            PROPERTY_ID: property.ARCIMEDES_ROW_ID,
        }
    }).then(res => {
        if (res.success && res.data.length) {
            axios({
                method: 'post',
                url: url,
                headers: {'Accept': '*'},
                data: {
                    PROPERTY_ID: res.data[0].ARCIMEDES_ROW_ID,
                    STATUS: res.data[0].STATUS,
                    NAME: res.data[0].NAME,
                    CITY: res.data[0].CITY,
                    STATE: res.data[0].STATE,
                    LIST_PRICE: res.data[0].LIST_PRICE,
                    CAPITALIZATION_RATE: res.data[0].CAPITALIZATION_RATE,
                    AGENT_1_FIRST_NAME: res.data[0].AGENT_1_FIRST_NAME,
                    AGENT_1_LAST_NAME: res.data[0].AGENT_1_LAST_NAME,
                    AGENT_2_FIRST_NAME: res.data[0].AGENT_2_FIRST_NAME,
                    AGENT_2_LAST_NAME: res.data[0].AGENT_2_LAST_NAME,
                    AGENT_3_FIRST_NAME: res.data[0].AGENT_3_FIRST_NAME,
                    AGENT_3_LAST_NAME: res.data[0].AGENT_3_LAST_NAME,
                    EMAIL_ENV: '',
                },
            });
        }
    });
}

